import { useUserStore } from '@/stores/user';

export default {
    async mounted(el, binding) {
        const user = JSON.parse(localStorage.getItem('user'))?.appUser || {};
        const permissions = useUserStore();
        await permissions.getUser(user);
        if (!permissions.checkPermissions(binding.value)) {
            el.style.display = 'none';
        }
    }
};
